import { Form, Spin } from "antd";
import { FunctionComponent } from "react";
import { useMediaQuery } from 'react-responsive';
import { EuroCircleOutlined } from "@ant-design/icons";
import { useAuth } from "../../hooks/AuthContext";
import { UnahtorizedAccess } from "../public/UnahtorizedAccess";
import { useTarifManagement } from "./tarifs/hooks/useTarifManagement";
import { TarifMobileView } from "./tarifs/TarifMobileView";
import { TarifDesktopView } from "./tarifs/TarifDesktopView";

export const AdminTarifs: FunctionComponent = () => {
    const { roles } = useAuth();
    const [form] = Form.useForm();
    const isMobile = useMediaQuery({ maxWidth: 768 });

    const {
        periodesDto,
        periodesOptions,
        selectedIdPeriode,
        viewTarif,
        openPopOver,
        application,
        currentPage,
        modalPeriodeOpen,
        createPeriode,
        periodeToEdit,
        isLoading,
        setCurrentPage,
        setOpenPopOver,
        setModalPeriodeOpen,
        onCreatePeriode,
        onModifierPeriode,
        onDeletePeriode,
        isSelectedPeriodeReadOnly,
        copierTarif,
        onFinish,
        onSelectPeriode,
        onApplicationChange,
    } = useTarifManagement(form);

    return roles?.includes("ROLE_ADMIN") ? (
        <div className="centered-content">
            <Form
                name="basic"
                autoComplete="off"
                className="container-full-width"
                onFinish={onFinish}
                form={form}
            >
                <Spin spinning={isLoading}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        padding: '20px 0 16px',
                        borderBottom: '3px solid #fa8c16',
                        marginBottom: '24px',
                    }}>
                        <div style={{
                            width: '48px',
                            height: '48px',
                            borderRadius: '12px',
                            background: 'linear-gradient(135deg, #fa8c16 0%, #ffa940 100%)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                            boxShadow: '0 4px 12px rgba(250, 140, 22, 0.35)',
                        }}>
                            <EuroCircleOutlined style={{ fontSize: '24px', color: '#fff' }} />
                        </div>
                        <div>
                            <div style={{ fontSize: '24px', fontWeight: 700, color: '#262626', lineHeight: 1.2 }}>
                                Administration des tarifs
                            </div>
                            <div style={{ fontSize: '13px', color: '#8c8c8c', marginTop: '2px' }}>
                                Gestion des périodes et tarifs par application
                            </div>
                        </div>
                    </div>
                    {isMobile ? (
                        <TarifMobileView
                            form={form}
                            application={application}
                            periodesDto={periodesDto}
                            periodesOptions={periodesOptions}
                            selectedIdPeriode={selectedIdPeriode}
                            viewTarif={viewTarif}
                            currentPage={currentPage}
                            openPopOver={openPopOver}
                            modalPeriodeOpen={modalPeriodeOpen}
                            createPeriode={createPeriode}
                            periodeToEdit={periodeToEdit}
                            onApplicationChange={onApplicationChange}
                            onSelectPeriode={onSelectPeriode}
                            onCreatePeriode={onCreatePeriode}
                            onModifierPeriode={onModifierPeriode}
                            onDeletePeriode={onDeletePeriode}
                            onFinish={onFinish}
                            onCopierTarif={copierTarif}
                            setCurrentPage={setCurrentPage}
                            setOpenPopOver={setOpenPopOver}
                            setModalPeriodeOpen={setModalPeriodeOpen}
                            isSelectedPeriodeReadOnly={isSelectedPeriodeReadOnly}
                        />
                    ) : (
                        <TarifDesktopView
                            form={form}
                            application={application}
                            periodesDto={periodesDto}
                            periodesOptions={periodesOptions}
                            selectedIdPeriode={selectedIdPeriode}
                            viewTarif={viewTarif}
                            currentPage={currentPage}
                            openPopOver={openPopOver}
                            modalPeriodeOpen={modalPeriodeOpen}
                            createPeriode={createPeriode}
                            periodeToEdit={periodeToEdit}
                            onApplicationChange={onApplicationChange}
                            onSelectPeriode={onSelectPeriode}
                            onCreatePeriode={onCreatePeriode}
                            onModifierPeriode={onModifierPeriode}
                            onDeletePeriode={onDeletePeriode}
                            onFinish={onFinish}
                            onCopierTarif={copierTarif}
                            setCurrentPage={setCurrentPage}
                            setOpenPopOver={setOpenPopOver}
                            setModalPeriodeOpen={setModalPeriodeOpen}
                            isSelectedPeriodeReadOnly={isSelectedPeriodeReadOnly}
                        />
                    )}
                </Spin>
            </Form>
        </div>
    ) : <UnahtorizedAccess />;
};